module.exports = __webpack_public_path__ + "static/media/5.7d1f1042.jpg";